import { Map, List, Record } from 'immutable'
import * as actions from './weatherActions'
import { logException } from '../../sentry'

export const WeatherDayRecord = Record({
  date: null,
  minTemperature: null,
  maxTemperature: null,
  symbol: null,
  // description: null, -- Not used, but we should for accessibility
  precipitation: '?',
  precipitationProbability: '?',
  windSpeed: '?',
  windDirection: '?',
  forecasts: List(),
}, 'weatherDay')

export const WeatherHourRecord = Record({
  datetime: null,
  temperature: null,
  feelsLike: null,
  precipitation: null,
  precipitationProbability: null,
  windSpeed: null,
  windDirection: null,
  symbol: null,
  // description: null, -- Not used, but we should for accessibility
}, 'weatherHour')


const initialState = Map({
  timestamp: null,
  failedToLoad: false,
  loading: false,
  currentLocationId: null,
  currentLocationName: '',
  currentLocationData: List(),
})

/**
 * Calculates 'windSpeed', 'windDirection', 'precipitation', 'precipitationProbability'
 * from hourly weather data.
 */
function calcDailyWeather(day) {
  try {
    let windSpeed = -1
    let windDirection = ''
    let precipitation = 0
    let precipitationProbability = 0
    for (const hour of day.forecasts) {
      precipitation += parseFloat(hour.precipitation)
      precipitationProbability = Math.max(precipitationProbability, parseInt(hour.precipitationProbability, 10))
      const hourWindSpeed = parseInt(hour.windSpeed, 10)
      if (hourWindSpeed > windSpeed) {
        windSpeed = hourWindSpeed
        windDirection = hour.windDirection
      }
    }
    return {
      windSpeed,
      windDirection,
      precipitation,
      precipitationProbability,
    }
  } catch (error) {
    logException(error)
  }
  return {}
}


export default function weatherReducer(state = initialState, action) {
  switch (action.type) {

    case actions.FETCH_WEATHER_SUCCESS:
    case actions.FETCH_WEATHER_BY_COORDINATES_SUCCESS:
      return state
        .set('currentLocationId', parseInt(action.response.data[0].locationId))
        .set('currentLocationName', action.response.data[0].locationName)
        .set('currentLocationData', normalizeWeatherData(action.response.data))
        .set('timestamp', action.timestamp)
        .set('loading', false)

    case actions.FETCH_WEATHER:
    case actions.FETCH_WEATHER_BY_COORDINATES:
      return initialState.set('loading', true)

    case actions.FETCH_WEATHER_FAILURE:
    case actions.FETCH_WEATHER_BY_COORDINATES_FAILURE:
      return initialState.set('failedToLoad', true).set('loading', false)

    default:
      return state
  }
}


function normalizeWeatherData(days) {
  return List(days.map(normalizeWeatherDay))
}

function normalizeWeatherDay(day) {
  const { windSpeed, windDirection, precipitation, precipitationProbability } = calcDailyWeather(day)
  return WeatherDayRecord({
    date: day.date,
    minTemperature: parseInt(day.minTemperature, 10),
    maxTemperature: parseInt(day.maxTemperature, 10),
    symbol: day.symbol,
    forecasts: List(day.forecasts.map(normalizeWeatherHour)),
    windSpeed,
    windDirection,
    precipitation,
    precipitationProbability,
    //description: day.description,
  })
}

function normalizeWeatherHour(hourData) {
  return WeatherHourRecord({
    datetime: hourData.datetime,
    temperature: parseInt(hourData.temperature, 10),
    feelsLike: parseInt(hourData.feelsLike, 10),
    precipitation: parseFloat(hourData.precipitation),
    precipitationProbability: parseInt(hourData.precipitationProbability, 10),
    windSpeed: parseInt(hourData.windSpeed, 10),
    windDirection: hourData.windDirection,
    symbol: hourData.symbol,
    //description: hourData.description,
  })
}
